export default __webpack_public_path__ + "static/pablo-book-lover-a7c88d8dbb1c4f88ef98151f28433b23.svg";